import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { Bloom } from './Bloom';
import { ConsolidationVisual } from './visuals/ConsolidationVisual';
import { packageIncludes } from '../data/site';
export function Pricing() {
  return <section id="pricing" className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-497" data-mp="2jjw7zccunmif">
      <Bloom size="lg" className="left-1/2 top-[-16rem] -translate-x-1/2" data-id="element-498" data-mp="1vts1mx8a18nq" />

      <div className="mx-auto w-full max-w-3xl px-6 py-20 lg:py-28" data-id="element-499" data-mp="1vvv2kcaywm78">
        <p className="text-center font-mono text-xs uppercase tracking-[0.2em] text-neutral-600" data-id="element-500" data-mp="1ru14mbs5pwar">
          What it replaces
        </p>
        <div className="mt-8" data-id="element-501" data-mp="20t4p9k6z2jrd">
          <ConsolidationVisual data-id="element-502" data-mp="20sv88m3wnmxt" />
        </div>

        <article className="mt-14 rounded-3xl border border-emerald-500/40 bg-[#0e1310] p-8 text-center sm:p-12" data-id="element-503" data-mp="20v7o8tq3rn88">
          <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-500" data-id="element-504" data-mp="3h97j3qa3cmom">
            The Complete System
          </h2>

          <p className="mt-8 flex items-baseline justify-center gap-2" data-id="element-505" data-mp="3w08ck3pope89">
            <span className="text-5xl font-bold tracking-tight text-white sm:text-6xl" data-id="element-506" data-mp="4svulmgz8wra">
              $1,197
            </span>
            <span className="text-base text-neutral-500" data-id="element-507" data-mp="9ryxp1decswm">/month</span>
          </p>
          <p className="mt-4 text-sm text-neutral-400" data-id="element-508" data-mp="erv6ddx1h8ii">
            Month to month. No contracts. We believe in earning it.
          </p>

          <ul className="mx-auto mt-10 grid max-w-xl grid-cols-1 gap-3.5 border-t border-[#1c2420] pt-10 text-left sm:grid-cols-2" data-id="element-509" data-mp="3daijpm5hf2iz">
            {packageIncludes.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-neutral-300" data-id="element-510" data-mp="3n63qdxlhwqz2">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-511" data-mp="3ry3pjntqrful" />
                {item}
              </li>)}
          </ul>

          <Link to="/contact" className="mt-10 inline-flex items-center gap-2 rounded-full bg-emerald-500 px-7 py-3.5 text-sm font-semibold text-[#0a0a0a] transition-colors hover:bg-emerald-400" data-id="element-512" data-mp="2zfznjsg4sv94">
            Book a 15-min call
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-513" data-mp="3177hoyi4bbg6" />
          </Link>
        </article>

        <div className="mt-8 rounded-2xl border border-[#1c1c1c] bg-[#0d0d0d] p-7" data-id="element-514" data-mp="2w7bdoz9f7k0m">
          <h3 className="font-mono text-xs uppercase tracking-[0.18em] text-neutral-500" data-id="element-515" data-mp="28hqs08lvu8nn">
            Running ads?
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-neutral-400" data-id="element-516" data-mp="23jz03el8mmjg">
            We manage your Yelp, Google, and Meta campaigns against booked jobs, not clicks. Added
            to your plan with a custom quote based on your budget and platforms.
          </p>
          <Link to="/contact" className="group mt-5 inline-flex items-center gap-2 text-sm font-semibold text-emerald-500 hover:text-emerald-400" data-id="element-517" data-mp="3tv3es4bln5dh">
            Get a custom quote
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-518" data-mp="a453vntx2r1" />
          </Link>
        </div>
      </div>
    </section>;
}